import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { xingxingListAll } from "@/api/xingxing";
export var gameXingxing = {
  namespaced: true,
  state: {
    isInit: 0,
    xingxingKv: {}
  },
  mutations: {
    setXingxingKv: function setXingxingKv(state, xingxingMap) {
      state.isInit = 1;
      state.xingxingKv = xingxingMap;
    }
  },
  actions: {
    getXingxing: function getXingxing(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, xingxingMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return xingxingListAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                xingxingMap = {};
                res.data.list.forEach(function (val) {
                  xingxingMap[val.xingxing_id] = val.xingxing_name;
                });
                commit("setXingxingKv", xingxingMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    xingxingMap: function xingxingMap(state) {
      return state.xingxingKv;
    }
  }
};